import { Pipe, PipeTransform } from '@angular/core';
import { TimeSlot } from '@thehubz/client/core';
import { differenceInMinutes } from 'date-fns';
import { ZERO_HOUR } from '../constants';

/**
 * Pipe to get total duration of time slots
 *
 * @param timeSlots Time slots
 */
@Pipe({
  name: 'totalDuration',
})
export class TotalDurationPipe implements PipeTransform {
  transform(timeSlots: TimeSlot | TimeSlot[]): string {
    if (!timeSlots) {
      return ZERO_HOUR;
    }
    if (!Array.isArray(timeSlots)) {
      timeSlots = [timeSlots];
    }

    const minutes = timeSlots.reduce((total, timeSlot) => {
      const minutes = getMinutes(timeSlot);
      total = total + minutes;
      return total;
    }, 0);

    const hours = toHoursAndMinutes(minutes);
    const timeString = `${hours.hours}`;
    if (hours.minutes !== undefined) {
      return `${timeString}:${hours.minutes.toString().padStart(2, '0')}`;
    }
    return timeString;
  }
}

/**
 * Get the duration of a time slot in minutes
 * @param timeSlot
 * @returns
 */
export function getMinutes(timeSlot: TimeSlot): number {
  if (!timeSlot.start || !timeSlot.end) {
    return 0;
  }

  const date = new Date();
  const startTime = timeSlot.start.split(':');
  const start = new Date(date.setHours(parseInt(startTime[0], 10), parseInt(startTime[1], 10)));
  const endTime = timeSlot.end.split(':');
  const end = new Date(date.setHours(parseInt(endTime[0], 10), parseInt(endTime[1], 10)));
  const diff = differenceInMinutes(end, start);

  return diff < 0 ? 0 : diff;
}

/**
 * Convert minutes to hours and minutes
 * @param minutes
 */
export function toHoursAndMinutes(minutes: number): Duration {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return { hours, minutes: mins };
}
